export const SERIF_FONT_FAMILY = 'Recoleta, Georgia, Times, serif';
